import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/service/api.service';
import { TopSellingService } from './top-selling.service';
import { CONSTANTS } from 'src/app/constants';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-top-selling',
  templateUrl: './top-selling.component.html',
  styleUrls: ['./top-selling.component.css']
})
export class TopSellingComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }

  @Output() errorEmitter = new EventEmitter();

  loading: boolean = true;
  errorApi = false;
  listProduct: { label: string, type: number, value: number }[] = [];
  typeSelected!: number;
  filterPlaceholder: string = 'Escolha um filtro';
  topTooltip: string = 'No Totvs Moda para exibir informação nesse painel é necessário configurar o parâmetro corporativo LST_TPCLAS_PRD_TA';
  topTooltipExcel: string = 'Download .xlsx';
  message: string = '';

  dataItem: any = {
    chart: {
      aligncaptionwithcanvas: "0",
      plottooltext:
        "<b>$dataValue</b>",
      theme: "gammel",
      decimalSeparator: ",",
      thousandSeparator: ".",
      showvalues: "1",
      placevaluesinside: "0"
    },
    data: []
  };

  width = '100%';
  height = '290';
  type = 'bar2d';
  dataFormat = 'json';
  dataSource = this.dataItem;
  dateFirst!: any;
  filterChange!: any;

  constructor(private api: ApiService, private topSellingService: TopSellingService, private router: Router) { }

  ngOnInit() {
    localStorage.setItem('top-selling', '');
  }

  filterItem(item: any) {
    this.loading = true;
    this.errorApi = false;
    this.filterChange = item;
    this.selectProduct().subscribe(data => {
      try {
        this.listProduct = [];
        if (data.dataRow.length != 0) {
          data.dataRow.map((el: any, index: any) => {
            this.listProduct.push({ value: index, label: el.classification_type_name, type: el.classification_type_code });
          })
          this.loading = false;
          this.errorApi = false;
          this.filterChange.branch.length != 0 ? this.recoverProduct(0) : null;
        } else {
          this.message = CONSTANTS.MESSAGES.DATA_NULL_TOP_SELLING;
          this.formatErrorMensagem(this.message);
          this.errorApi = true;
        }
      } catch (error: unknown){
        this.loading = false;
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_ERRO_TOP_SELLING;
        if (error instanceof Error)
          this.formatErrorMensagem(error.message);
      }
    }, error => {
      this.loading = false;
      this.errorApi = true;
      this.message = CONSTANTS.MESSAGES.DATA_ERRO_TOP_SELLING;
      this.formatErrorMensagem(error.message);
    })
  }

  selectProduct() {
    return this.api.getClassificationTypes()
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: top-selling \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }

  recoverProduct(item: any) {
    this.loading = true;
    let objFilter = {
      dataMin: this.filterChange.dataMin,
      dataMax: this.filterChange.dataMax,
      branch: this.filterChange.branch ? this.filterChange.branch : [],
      sellers: this.filterChange.sellers ? this.filterChange.sellers : [],
      type: this.listProduct[item].type
    }
    this.dataItem.data = [];
    this.topProduct(objFilter).subscribe(data => {
      try {
        let excelInfo = [];
        if (data.dataRow.length != 0) {
          data.dataRow.map((el: any) => {
            if (this.dataItem.data.length < 10) {
              this.dataItem.data.push({
                'label': el.classification_name,
                'value': el.item_quantity
              });
              excelInfo.push({'Data Inicial': this.filterChange.dataMin.toString(), 'Data Final': this.filterChange.dataMax.toString(), 'Código Filiais': this.filterChange.branch.toString(), 'Classificação': this.listProduct[item].label, 'Nome': el.classification_name.toString(), 'Valor': 'R$' + el.item_quantity.toString()});
            }
          })
          excelInfo.unshift({});
          localStorage.setItem('top-selling', JSON.stringify(excelInfo));
          this.loading = false;
          this.errorApi = false;
          this.typeSelected = parseInt(item);
        } else {
          this.typeSelected = parseInt(item);
          this.message = CONSTANTS.MESSAGES.DATA_NULL_TOP_SELLING;
          this.errorApi = true;
          this.loading = false;
          this.formatErrorMensagem(this.message);
        }
      } catch (error: unknown) {
        this.loading = false;
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_ERRO_TOP_SELLING;
        if (error instanceof Error)
          this.formatErrorMensagem(error.message);
      }
    }, error => {
      this.loading = false;
      this.errorApi = true;
      this.message = CONSTANTS.MESSAGES.DATA_ERRO_TOP_SELLING;
      this.formatErrorMensagem(error.message);
    });
  }

  downloadExcel() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataTopSelling = [];
    let objectTopSelling = localStorage.getItem('top-selling');

    objectTopSelling != null
      ? (dataTopSelling = JSON.parse(objectTopSelling))
      : (dataTopSelling = []);
    const worksheetTopSelling= XLSX.utils.json_to_sheet(dataTopSelling);

    const workbook = {
      Sheets: {
        'top-10-mais-vendidos': worksheetTopSelling,
      },
      SheetNames: [
        'top-10-mais-vendidos',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-top-10-mais-vendidos' + EXCEL_EXTENSION);
  }

  topProduct(item: any) {
    return this.api.postClassificationProduct(item.dataMin, item.dataMax, item.branch, item.sellers, item.type);
  }

  goToTopSelling() {
    localStorage.setItem('filterInfoBranchs', JSON.stringify(this.filterChange.branch));
    localStorage.setItem('filterInfoMinDate', JSON.stringify(this.filterChange.dataMin));
    localStorage.setItem('filterInfoMaxDate', JSON.stringify(this.filterChange.dataMax));
    localStorage.setItem('filterInfoSellers', JSON.stringify(this.filterChange.sellers));
    if (this.filterChange.dataMax == undefined || this.filterChange.dataMin == undefined) {
      this.router.navigate(['/selling-products'],
        { queryParams: { 'type': this.listProduct[this.typeSelected].type, 'value': this.listProduct[this.typeSelected].value, 'dateMin': this.dateFirst, 'dateMax': this.dateFirst, 'branch': [] } }
      );
    } else {
      let dateMin = this.filterChange.dataMin.split(' ');
      let dateMax = this.filterChange.dataMax.split(' ');
      this.router.navigate(['/selling-products'],
        { queryParams: { 'type': this.listProduct[this.typeSelected].type, 'value': this.listProduct[this.typeSelected].value, 'dateMin': dateMin[0], 'dateMax': dateMax[0], 'branch': this.filterChange.branch } }
      );
    }
  }

  saveFilter(item: any) {
    this.topSellingService.onSaveLocalsStore(this.listProduct[item].type);
  }

  loadFilterDefault() {
    var filterId = this.topSellingService.onLoadLocalsStore();

    if (filterId !== '')
      this.typeSelected = filterId;
  }

}
